module.exports = __webpack_public_path__ + "static/section2-e2716f889fd9b11d8749fff73eb164e5.svg";